import { Action } from "../../models/Action";
import {
  SET_EXERCISEDESCRIPTION,
  SET_EXERCISENAME, SET_EXERCISEZONEID,
} from "./pseudoModalsTypes";

export interface PseudoModalState {
  exerciseName: string;
  exerciseZoneId: number | null;
  exerciseDescription: string;
}

const initialPseudoModals = {
  exerciseName: "",
  exerciseZoneId: 999,
};

export default function pseudoModalsReducer(pseudoModals = initialPseudoModals, action: Action<any>) {
  switch (action.type) {

    case SET_EXERCISENAME:
      return { ...pseudoModals, exerciseName: action.payload };
      case SET_EXERCISEZONEID:
        return { ...pseudoModals, exerciseZoneId: action.payload };
        case SET_EXERCISEDESCRIPTION:
          return { ...pseudoModals, exerciseDescription: action.payload };
    default:
      return pseudoModals;
  }
};


